// App.jsx
import "./styles/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import Home from "./pages/Home";
import AudioAnalyzer from "./pages/AudioAnalyzer";
import AwayFromHome from "./pages/AwayFromHome";
import Mileage from "./pages/Mileage";
import QHelper from "./pages/QHelper";
import Quizzer from "./pages/Quizzer";
import QuantifyingHappiness from "./pages/QuantifyingHappiness";
import WritingArticlePage from "./pages/WritingArticlePage";
import TopBar from "./components/TopBar";
import ScrollToTop from "./components/ScrollToTop";

function App() {
  return (
    <BrowserRouter>
      <ScrollToTop />
      <div className="App">
        <header className="App-header">
          <TopBar />
        </header>

        <main className="main-content">
          <Routes>
            <Route path="/" element={<Home />} />

            {/* Individual Project Pages */}
            <Route
              path="/projects/quantifyinghappiness"
              element={<QuantifyingHappiness />}
            />
            <Route path="/projects/mileage" element={<Mileage />} />
            <Route path="/projects/quizzer" element={<Quizzer />} />
            <Route path="/projects/awayfromhome" element={<AwayFromHome />} />
            <Route path="/projects/qhelper" element={<QHelper />} />
            <Route path="/projects/audioanalyzer" element={<AudioAnalyzer />} />

            {/* Generic Writing Page */}
            <Route path="/writing/:slug" element={<WritingArticlePage />} />

            {/* Retired listing pages and anything else fall back to Home */}
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
        </main>
      </div>
    </BrowserRouter>
  );
}

export default App;
